<template>
<div>
    <div class="nav">
        <div class="logo" v-if="!isMobiles">
            <el-image :src="header_1" alt />
            <!-- <div class="logo-txt">
                <div class="txt-name">东风南方保代</div>
                <div class="txt-nameE">DFSI</div>
            </div> -->
            <!-- <el-image :src="require('../../../assets/logo.png')" /> -->
            <!-- <div class="txt">
                <span>东风南方保代</span>
                <span>DFSI</span>
            </div> -->
        </div>
        <div class="page">
            <div class="page-div" :class="active === '网站首页' ? 'active' : 'item'" @click="changeList('网站首页')">网站首页</div>
            <div class="page-div" :class="active === '热销产品' ? 'active' : 'item'" @click="changeList('热销产品')">热销产品</div>
            <div class="page-div" :class="active === '信息披露' ? 'active' : 'item'" @click="changeList('信息披露')">信息披露</div>
            <div class="page-div" :class="active === '关于我们' ? 'active' : 'item'" @click="changeList('关于我们')">关于我们</div>
            <div class="page-div" :class="active === '加入我们' ? 'active' : 'item'" @click="changeList('加入我们')">加入我们</div>
            <div class="info" v-if="!isMobiles">
                <div class="info-pot">|</div>
                <div class="info-phone">
                    <el-image class="phone-img" :src="header_2" fit="cover" />
                    020-36878670
                </div>
                <div class="info-a">
                    <el-image class="a-img" :src="header_3" fit="cover" />
                    <a href="https://www.dfsi.cn/" target="_blank" rel="noopener noreferrer">www.dfsi.cn</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    isMobile
} from '../../../libs/util'
export default {
    data() {
        return {
            active: '网站首页',
            header_1: require("../../../assets/logo.png"),
            header_2: require("../../../assets/header_2.png"),
            header_3: require("../../../assets/header_3.png"),
            isMobiles: false
        };
    },
    created() {
        this.active = this.$route.meta.title
        this.isMobiles = isMobile()
    },
    methods: {
        changeList(v) {
            this.active = v
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0
            switch (v) {
                case "网站首页":
                    this.$router.push({
                        path: "/home"
                    }).catch(err => err);
                    break;
                case "热销产品":
                    this.$router.push({
                        path: "/product"
                    }).catch(err => err);
                    break;
                case "信息披露":
                    if (JSON.parse(sessionStorage.getItem('hebei'))) {
                        if (this.isMobiles) {
                            this.$router.push({
                                path: "/informationmobilehb"
                            }).catch(err => err)
                        } else {
                            this.$router.push({
                                path: "/informationhb"
                            }).catch(err => err)
                        }
                    } else {
                        if (this.isMobiles) {
                            this.$router.push({
                                path: "/informationmobile"
                            }).catch(err => err)
                        } else {
                            this.$router.push({
                                path: "/information"
                            }).catch(err => err)
                        }
                    }
                    break;
                case "关于我们":
                    this.$router.push({
                        path: "/about"
                    }).catch(err => err);
                    break;
                case "加入我们":
                    this.$router.push({
                        path: "/join"
                    }).catch(err => err);
                    break;
            }
        }
    }
};
</script>

<style lang="less" scoped>
.header {
    height: 22px;
    padding: 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;

    .header-title {
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: flex-end;
        width: 80%;
    }

    a {
        text-decoration: none;
        color: white;
    }

    a:hover {
        color: #0476c3;
    }
}

.nav {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 2.67rem;
    width: 100%;
    background-color: #636363;
    // margin: 10px auto 0px;

    .logo {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #eeeeee;
        margin-left: 4.2rem;

        .el-image {
            width: 10.5rem;
            // height: 1.87rem;
        }

        // .logo-txt {
        //     display: flex;
        //     flex-direction: column;
        //     align-items: center;
        //     font-size: 1rem;
        //     font-weight: bold;
        //     margin-left: 0.5rem;
        //     letter-spacing: 1px;
        //     .txt-nameE {
        //         font-size: .8rem;
        //         letter-spacing: 3px;
        //     }
        // }
    }

    .page {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        // width: 600px;
        color: #FFFFFF;
        font-size: .6rem;

        .page-div {
            width: 4.6rem;
            cursor: pointer;
        }

        .active {
            color: #FF9600;
        }

        .item:hover {
            color: #ffb171;
        }

        .info {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            margin-right: 3.2rem;

            .info-a {
                display: flex;
                align-items: center;
                margin-left: 1.97rem;

                .a-img {
                    width: 0.93rem;
                    height: 0.93rem;
                }
            }

            .info-phone {
                display: flex;
                align-items: center;
                margin-left: 1.63rem;

                .phone-img {
                    width: 0.93rem;
                    height: 0.93rem;
                }
            }

            a {
                text-decoration: none;
                color: white;
            }

            a:hover {
                color: #FF9600;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/view/layout/components/header.vue